<template>
    <div id="patients-portal-dashboard-container">
        <MdTitle v-bind:Text="$t('PatientPortalDashboard.Title')" />

        <b-row>
            <b-col md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.PortalStatus')"
                    v-bind:Options="patientPortalStatusOptions"
                    v-bind:ModelArray="portalStatus"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    :Input="changePortalStatus"
                />
            </b-col>
            <!-- 
            <b-col md="3" sm="12">
                <MdLookupMultiSelect
                    v-bind:Label="$tc('Shared.Patient', 2)"
                    v-bind:ModelCode="patientCodeModel"
                    v-bind:RefCode="'patientcode'"
                    v-bind:Api="'Patients'"
                    v-bind:FieldCode="'patientcode'"
                    v-bind:FieldDescription="'firstname'"
                    :SearchTitle="$tc('Shared.Patient', 2)"
                    :GetValues="getPatientValues"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :SearchFieldCode="'PatientCode'"
                    :AuxFields="patientAuxFields"
                    :FieldsDate="patientFieldsDate"
                    :ServerSidePagination="true"
                    v-bind:Fields="patientLookupFields"
                />
            </b-col>

            <b-col md="3" sm="12">
                <div class="text-md-right mt-3">
                    <button
                        v-on:click="searchPatient"
                        type="button"
                        class="btn btn-primary btn-login mx-2"
                        id="btnsearchinput"
                    >
                        {{ $t('Shared.Search') }}
                    </button>
                </div>
            </b-col>
            -->            
        </b-row>

        <MdTitle
            v-bind:Text="$t('Shared.SearchResult')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col class="col-12 mt-2">
                <MdTable
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:VisibleEditIcon="false"
                    v-bind:IsPatientPortalDashboard="true"
                    v-bind:FieldsDate="fieldsDateArr"
                    v-bind:multiSelect="true"
                    v-bind:ShowSelectAll="true"
                    v-bind:ShowSelectedCount="true"
                    v-bind:ShowSearchCriteria="true"
                    v-bind:SelectionKey="'patientCode'"
                    v-bind:SelectAllFunction="getAllPatientsForSelectAll"
                    :onSearchCriteria="onSearchCriteriaChanged"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="perPageFunction"
                    :viewIconEvent="openSummary"
                    @selectionChanged="onSelectionChanged"
                    ref="dashboardTable"
                >
                </MdTable>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <b-button
                variant="outline-secondary"
                class="inlineBadge"
                @click="openChangePatInfo"
                v-if="this.$store.state.isPatientPortalChangeInformation"
            >
                {{ $t('PatientPortalDashboard.RightBar.ChangePatInfo') }}
                <b-badge v-if="changePatInfoCount > 0" variant="danger" pill class="ml-1">
                    {{ changePatInfoCount }}
                </b-badge>
            </b-button>
            <b-button
                variant="outline-secondary"
                class="ml-2 inlineBadge"
                @click="openMessages"
                v-if="this.$store.state.isPatientPortalMessage"
            >
                {{ $t('PatientPortalDashboard.RightBar.Messages') }}
                <b-badge v-if="messagesCount > 0" variant="danger" pill class="ml-1">
                    {{ messagesCount }}
                </b-badge>
            </b-button>
            <b-dropdown
                id="dropdown-dropup"
                dropup
                :text="$tc('Shared.ActionsTxt', 2)"
                variant="primary"
                class="m-2"
                :disabled="!buttonActionEnabled"
            >
                <b-dropdown-item href="#" v-on:click="openContacts" v-if="contactsVisible">
                    {{ $t('Shared.Title') }}
                </b-dropdown-item>
                <b-dropdown-item href="#" v-on:click="openClaims" v-if="claimsVisible">
                    {{ $t('Shared.Claim') }}
                </b-dropdown-item>
                <b-dropdown-item href="#" v-if="isNotify('email')" v-on:click="showNotify('email')">
                    {{ $t('Shared.EmailPatient') }}
                </b-dropdown-item>
                <b-dropdown-item href="#" v-if="isNotify('text')" v-on:click="showNotify('text')">
                    {{ $t('Shared.TextPatient') }}
                </b-dropdown-item>
                <b-dropdown-item
                    href="#"
                    v-if="letterTemplateVisible"
                    v-on:click="printLetterTemplate"
                >
                    {{ $t('PatientPortalDashboard.Dropdown.PrintLetter') }}
                </b-dropdown-item>
                <b-dropdown-item
                    href="#"
                    v-if="isCreateCredentialsEnabled"
                    v-on:click="createCredentials"
                >
                    {{ $t('PatientPortalDashboard.Dropdown.CreateCredentials') }}
                </b-dropdown-item>
                <b-dropdown-item
                    href="#"
                    v-if="isChangePasswordEnabled"
                    v-on:click="changePassword"
                >
                    {{ $t('Shared.ChangePassword') }}
                </b-dropdown-item>
            </b-dropdown>
        </div>

        <MDTextEditorDialog
            :visible="textEditorVisible"
            :value="textEditorValue"
            @close="closeTextEditorHandler"
            @ok="closeTextEditorHandler"
            :handlerOk="closeTextEditorHandler"
            :required="false"
            :buttonSaveHidden="true"
            :isReadOnly="true"
            :title="$t('PatientPortalDashboard.Title')"
        >
        </MDTextEditorDialog>

        <patient-portal-change-password
            :visible.sync="changePasswordVisible"
            :userName="selectedUserName"
        ></patient-portal-change-password>

        <patient-portal-create-login
            :visible.sync="createLoginVisible"
            :patientCode="patientCodeFirstOrDefault"
            :fullName="selectedFullName"
            :email="selectedEmail"
            @ok="createLoginHandler"
        ></patient-portal-create-login>

        <patient-portal-change-user-name
            :visible.sync="changeUserNameVisible"
            :patientCode="patientCodeFirstOrDefault"
            :fullName="selectedFullName"
            :userName="selectedUserName"
            @ok="createLoginHandler"
        ></patient-portal-change-user-name>

        <patient-portal-notify
            :visible.sync="notifyVisible"
            :patientCodeList="selectedPatientCodeList"
            :notifyType="notifyType"
            :notifyTemplateList="
                notifyType === 'email' ? notifyEmailTemplateList : notifyTextTemplateList
            "
        >
        </patient-portal-notify>

        <patient-portal-letter
            :visible.sync="letterVisible"
            :patientCodeList="selectedPatientCodeList"
            :letterTemplateList="letterTemplateList"
        >
        </patient-portal-letter>
    </div>
</template>

<script>
import EnumService from '@/services/enum.service';
import PatientPortalsService from '@/services/patientportals.service';
import PatientPortalChangeInfoService from '@/services/patientPortalChangeInfo.service';
import PatientPortalMessageService from '@/services/patientPortalMessages.service';
import LetterTemplatesService from '@/services/lettertemplates.service.js';
import Utils from '@/common/utils';
import { EventBus } from '@/event-bus.js';
import PatientsPortalBase from './patientsPortalBase.vue';
import { patientsPortalStore } from './patientsPortalStore';
import PatientPortalChangePassword from './dialogs/patientPortalChangePassword.vue';
import PatientPortalCreateLogin from './dialogs/patientPortalCreateLogin.vue';
import PatientPortalChangeUserName from './dialogs/patientPortalChangeUserName.vue';
import PatientPortalNotify from './dialogs/patientPortalNotify.vue';
import PatientPortalLetter from './dialogs/patientPortalLetter.vue';

export default {
    name: 'PatientsPortalDashboard',
    extends: PatientsPortalBase,
    components: {
        PatientPortalChangePassword,
        PatientPortalCreateLogin,
        PatientPortalChangeUserName,
        PatientPortalNotify,
        PatientPortalLetter
    },
    data() {
        return {
            parameters: {
                searchCriteria: '',
                status: null,
                portalStatus: null,
                PatientCodeList: []
            },
            patientCodeModel: [],
            patientAuxFields: ['lastname'],
            patientFieldsDate: ['dob'],
            patientLookupFields: [
                { key: 'firstname', sortable: true, label: this.$t('Shared.FirstName') },
                { key: 'lastname', sortable: true, label: this.$t('Shared.LastName') },
                { key: 'patientcode', sortable: true, label: this.$t('Shared.Code') },
                { key: 'dob', sortable: true, label: this.$t('Shared.Dob') },
                { key: 'cellPhone', sortable: true, label: this.$t('Shared.CellPhone') },
                { key: 'email', sortable: true, label: this.$t('Shared.Email') },
                { key: 'address1', sortable: true, label: this.$t('Shared.Address1') },
                { key: 'city', sortable: true, label: this.$t('Shared.City') },
                { key: 'state', sortable: true, label: this.$t('Shared.State') },
                { key: 'zip', sortable: true, label: this.$t('Shared.Zip') }
            ],
            items: [],
            totalRows: 0,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            perPage: 10,
            fields: [
                {
                    key: 'patientName',
                    sortable: true,
                    label: this.$t('Shared.PatientName'),
                    class: 'text-left'
                },
                {
                    key: 'patientCode',
                    sortable: true,
                    label: this.$t('Shared.PatientCode'),
                    class: 'text-left'
                },
                {
                    key: 'dob',
                    sortable: true,
                    label: this.$t('Shared.Dob'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'portalStatusTranslated',
                    sortable: true,
                    label: this.$t('Shared.PortalStatus'),
                    class: 'text-left'
                },
                {
                    key: 'userName',
                    sortable: true,
                    label: this.$t('Shared.UserName'),
                    class: 'text-left'
                },
                {
                    key: 'email',
                    sortable: true,
                    label: this.$t('Shared.Email'),
                    class: 'text-left'
                },
                {
                    key: 'cellPhone',
                    sortable: true,
                    label: this.$t('Shared.CellPhone'),
                    class: 'text-left'
                },
                {
                    key: 'dayPhone',
                    sortable: true,
                    label: this.$t('Shared.DayPhone'),
                    class: 'text-left'
                },
                {
                    key: 'nightPhone',
                    sortable: true,
                    label: this.$t('Shared.NightPhone'),
                    class: 'text-left'
                },
                {
                    key: 'address1',
                    sortable: true,
                    label: this.$t('Shared.Address1'),
                    class: 'text-left'
                },
                {
                    key: 'address2',
                    sortable: true,
                    label: this.$t('Shared.Address2'),
                    class: 'text-left'
                },
                {
                    key: 'city',
                    sortable: true,
                    label: this.$t('Shared.City'),
                    class: 'text-left'
                },
                {
                    key: 'state',
                    sortable: true,
                    label: this.$t('Shared.State'),
                    class: 'text-left'
                },
                {
                    key: 'zip',
                    sortable: true,
                    label: this.$t('Shared.Zip'),
                    class: 'text-left'
                }
            ],

            fieldsDateArr: ['dob'],
            showMessageIsEmpty: false,
            patientListStatus: EnumService.PatientListStatus,
            patientPortalStatusOptions: EnumService.PatientPortalStatusOptions,
            status: { value: true, text: this.$t('Shared.Active') },
            portalStatus: { value: null, text: this.$t('Shared.All') },
            letterTemplateList: [],
            letterVisible: false,
            changePatInfoCount: 0,
            changePatInfoPollTimer: null,
            messagesCount: 0
        };
    },

    computed: {
        dashboardTable() {
            return this.$refs.dashboardTable;
        },
        buttonActionEnabled() {
            return this.claimsVisible || this.contactsVisible;
        },
        isChangePasswordEnabled() {
            const item = this.selectedItems.length === 1 ? this.selectedItems[0] : null;
            return (
                this.$store.state.isPatientPortalChangePassword &&
                item &&
                item.portalStatus === 'Enrolled'
            );
        },
        isCreateCredentialsEnabled() {
            const item = this.selectedItems.length === 1 ? this.selectedItems[0] : null;
            return (
                this.$store.state.isPatientPortalCreateCredentials &&
                ((this.selectedItems.length > 1 &&
                    this.selectedItems.every(x => x.portalStatus === 'Not Enrolled')) ||
                    (item &&
                        item.portalStatus === 'Not Enrolled' &&
                        Utils.isNullOrEmptyString(item.userName) &&
                        !Utils.isNullOrEmptyString(item.email) &&
                        !!item.dob))
            );
        },
        letterTemplateVisible() {
            return (
                this.$store.state.isPatientPortalPrintLetter &&
                this.selectedItems.length !== 0 &&
                this.letterTemplateList.length !== 0
            );
        },
        contactsVisible() {
            return this.$store.state.isPatientPortalContacts;
        },
        claimsVisible() {
            return this.$store.state.isPatientPortalClaims;
        }
    },

    methods: {
        printLetterTemplate() {
            this.letterVisible = true;
        },

        updateMenu(arr) {
            this.OptionsRightMenu.visible = false;
            this.OptionsRightMenu.btnPatientsPortalDashboardVisible = this.selectedItems.length > 0;
            this.OptionsRightMenu.ItemsList = arr;
            this.OptionsRightMenu.skipLoadLayout = true;
            this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);
        },

        openContacts() {
            patientsPortalStore.selectedPatientCodeList =
                this.selectedItems.length > 0 ? this.selectedPatientCodeList : null;
            this.$router.push({ name: 'patients-portal-contacts' });
        },

        openClaims() {
            patientsPortalStore.selectedPatientCodeList =
                this.selectedItems.length > 0 ? this.selectedPatientCodeList : null;
            this.$router.push({ name: 'patients-portal-claims' });
        },

        openSummary(item) {
            patientsPortalStore.selectedItem = item;
            this.$router.push({
                name: 'patients-portal-summary',
                params: { id: item.patientCode }
            });
        },

        enabledAllItems() {
            const item = this.selectedItems.length === 1 ? this.selectedItems[0] : null;
            let arr = this.RightMenuList;
            arr.forEach(element => {
                let buttonEnabled = false;
                switch (element.value) {
                    case 'PPDB_CreateCredentials':
                        buttonEnabled =
                            (this.selectedItems.length > 1 &&
                                this.selectedItems.every(x => x.portalStatus === 'Not Enrolled')) ||
                            (item &&
                                item.portalStatus === 'Not Enrolled' &&
                                Utils.isNullOrEmptyString(item.userName) &&
                                !Utils.isNullOrEmptyString(item.email) &&
                                !!item.dob);
                        break;
                    case 'PPDB_CreateAuthLogins':
                        buttonEnabled =
                            this.selectedItems.length > 1 ||
                            (item &&
                                Utils.isNullOrEmptyString(item.userName) &&
                                !Utils.isNullOrEmptyString(item.email));
                        break;
                    case 'PPDB_CreateLogin':
                        buttonEnabled =
                            item &&
                            Utils.isNullOrEmptyString(item.userName) &&
                            !Utils.isNullOrEmptyString(item.email);
                        break;
                    case 'PPDB_ChangeUsername':
                    case 'PPDB_ChangePassword':
                        buttonEnabled = item && !Utils.isNullOrEmptyString(item.userName);
                        break;
                    case 'PPDB_PatientForms':
                    case 'PPDB_PatientContacts':
                    case 'PPDB_PatientClaims':
                    case 'PPDB_PatientInfo':
                    case 'PPDB_ChangePatInfo':
                    case 'PPDB_Messages':
                        buttonEnabled = !!item;
                        break;
                    default:
                        break;
                }

                element.ReadOnly = !buttonEnabled;
            });
        },

        afterCreateCredentials() {
            this.listingAsync();
        },

        onSelectionChanged(items) {
            this.selectedItems = items;
        },

        onSearchCriteriaChanged(criteria) {
            this.parameters.searchCriteria = criteria;
            this.searchPatient();
        },

        async getAllPatientsForSelectAll(searchCriteria) {
            const parameters = {
                searchCriteria:
                    searchCriteria !== undefined ? searchCriteria : this.parameters.searchCriteria,
                status: this.parameters.status,
                portalStatus: this.parameters.portalStatus,
                PatientCodeList: this.parameters.PatientCodeList
            };
            const response = await PatientPortalsService.getAllDashboard(parameters);
            if (response.status === 200 && response.data) {
                return response.data;
            }
            return [];
        },

        onFiltered() {},

        pageChanged(page) {
            this.currentPage = page;
            this.listingAsync();
        },

        perPageFunction(perPage) {
            this.perPage = perPage;
            this.currentPage = 1;
            this.listingAsync();
        },

        changeStatus(status) {
            this.parameters.status = !status || status.value === 'All' ? null : status.value;
            this.searchPatient();
        },

        changePortalStatus(value) {
            this.parameters.portalStatus = value ? value.value : null;
            this.searchPatient();
        },

        getPatientValues(value) {
            this.patientCodeModel = value;
            this.parameters.PatientCodeList = value || [];
            this.searchPatient();
        },

        searchPatient() {
            this.dashboardTable.clearSelection();
            this.currentPage = 1;
            this.listingAsync();
        },

        async listingAsync() {
            const parameters = {
                PageSize: this.perPage,
                PageNumber: this.currentPage,
                searchCriteria: this.parameters.searchCriteria,
                status: this.parameters.status,
                portalStatus: this.parameters.portalStatus,
                PatientCodeList: this.parameters.PatientCodeList
            };

            await PatientPortalsService.getAllDashboard(parameters)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        let headerString = response.headers['x-pagination'];
                        const header = JSON.parse(headerString);
                        this.totalRows = header.TotalCount;
                    }

                    this.showMessageIsEmpty = this.totalRows === 0;
                    this.enabledAllItems();
                    EventBus.$emit('cleanPatientInfo');
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getLetterTemplate() {
            await LetterTemplatesService.getPatientPortalLookup()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.letterTemplateList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        openChangePatInfo() {
            this.$router.push({ name: 'patients-portal-change-info' });
        },

        openMessages() {
            this.$router.push({ name: 'patients-portal-message' });
        },

        async loadChangePatInfoCount() {
            try {
                const response = await PatientPortalChangeInfoService.getNewRequestsCount();
                if (response.status === 200 && response.data !== undefined) {
                    this.changePatInfoCount = response.data;
                }
            } catch {
                // count stays 0 if the request fails
            }
        },

        async loadMessagesCount() {
            try {
                const response = await PatientPortalMessageService.getNewRequestsCount();
                if (response.status === 200 && response.data !== undefined) {
                    this.messagesCount = response.data;
                }
            } catch {
                // count stays 0 if the request fails
            }
        },

        initialize() {
            Promise.allSettled([
                this.listingAsync(),
                this.getLetterTemplate(),
                this.loadChangePatInfoCount(),
                this.loadMessagesCount()
            ]);
        },

        createLoginHandler(item) {
            var indexOf = this.items.findIndex(x => x.patientCode === item.patientCode);

            if (indexOf !== -1) {
                this.$set(this.items, indexOf, item);
            }
        }
    },

    async mounted() {
        this.OptionsRightMenu.btnPatientsPortalDashboardVisible = false;
        this.$emit('onMenuRightBarPatientsPortalDashboard', this.OptionsRightMenu);
        this.initialize();
        this.changePatInfoPollTimer = setInterval(() => {
            this.loadChangePatInfoCount();
            this.loadMessagesCount();
        }, 300000);
    },

    beforeDestroy() {
        clearInterval(this.changePatInfoPollTimer);
    }
};
</script>
